import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments';
import { Observable } from 'rxjs';
import { TreatmentDesignActionRequest } from '../models';

const basePath = `${environment.apiBaseUrl}treatment-design-action`;

@Injectable({ providedIn: 'root' })
export class TreatmentDesignActionApiClient {
    private readonly _http = inject(HttpClient);

    requestAction(model: TreatmentDesignActionRequest): Observable<{}> {
        return this._http.post(`${basePath}/request-action`, model);
    }
}
